import React from "react";
import { ReactElement } from "react";
import styled from "styled-components";

interface ToggleProps {
    onChange(): void;
    active: boolean;
    disabled?: boolean;
}

const Container = styled.label`
  position: relative;
  display: inline-block;
  width: 42px;
  height: 26px;
  outline: none;
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e0e3dd;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  outline: none;
  &:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 6px;
    bottom: 6px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
    outline: none;
  }
`;

const Input = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  outline: none;
  visibility: hidden;
  &:checked + ${Slider} {
    background-color: #7cc242;
  }
  &:focus + ${Slider} {
    box-shadow: 0 0 1px #7cc242;
  }
  &:checked + ${Slider}:before {
    transform: translateX(14px);
  }
  &:disabled + ${Slider} {
    background-color: #e0e3dd;
  }
`;

const Toggle = (props: ToggleProps): ReactElement => {
    return (
        <Container>
            <Input checked={props.active} onChange={props.onChange} type={"checkbox"} disabled={props.disabled} />
            <Slider />
        </Container>
    );
};

export default Toggle;
